import { COMPLETE_TUTORIAL } from '../constants/actions';

export const completeTutorial = screen => {
    return {
        type: COMPLETE_TUTORIAL,
        screen,
    };
};
